import script from "./MOTDToast.vue?vue&type=script&setup=true&lang=js"
export * from "./MOTDToast.vue?vue&type=script&setup=true&lang=js"

import "./MOTDToast.vue?vue&type=style&index=0&id=5263a0e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5263a0e6"]])

export default __exports__